export const timeOutPromise = (func, timeout) => {
  return new Promise(resolve => {
    setTimeout(() => {
      func();
      resolve('done');
    }, timeout);
  });
};
